import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  $serializer_getInstance1w32yf0zne1cd as $serializer_getInstance,
  Companion_getInstancewd0gqnmrfyoi as Companion_getInstance,
  GrantedScopejxz7dn7szihe as GrantedScope,
} from '../../../../../lightning-server-auth-shared/com/lightningkite/lightningserver/auth/Scope.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Index2tzg8vllut89f as Index,
  AdminTableColumns127mx0x3shj3w as AdminTableColumns,
  IndexSetppgakdbfpe00 as IndexSet,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import {
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId24qpfucecockd as HasId } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import {
  $serializer_getInstanceaabpkscl6h1l as $serializer_getInstance_0,
  $serializer_getInstance1wkzh194ew9wf as $serializer_getInstance_1,
} from './proofs/proofModels.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function Session$Companion$$childSerializers$_anonymous__rup784() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
function Session$Companion$$childSerializers$_anonymous__rup784_0() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
function Session$Companion$$childSerializers$_anonymous__rup784_1() {
  return new (LinkedHashSetSerializer())($serializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Session$Companion$$childSerializers$_anonymous__rup784);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Session$Companion$$childSerializers$_anonymous__rup784_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, null, null, null, null, null, null, null, tmp_1, tmp_3, lazy(tmp_4, Session$Companion$$childSerializers$_anonymous__rup784_1)];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.Session', null, 14);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('secretHash', false);
        tmp0_serialDesc.addElement_5pzumi_k$('derivedFrom', true);
        tmp0_serialDesc.addElement_5pzumi_k$('label', true);
        tmp0_serialDesc.addElement_5pzumi_k$('subjectId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('createdAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('authenticatedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('lastUsed', false);
        tmp0_serialDesc.addElement_5pzumi_k$('expires', true);
        tmp0_serialDesc.addElement_5pzumi_k$('stale', true);
        tmp0_serialDesc.addElement_5pzumi_k$('terminated', true);
        tmp0_serialDesc.addElement_5pzumi_k$('ips', true);
        tmp0_serialDesc.addElement_5pzumi_k$('userAgents', true);
        tmp0_serialDesc.addElement_5pzumi_k$('scopes', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_5gdsw7_k$(typeSerial0, typeSerial1) {
        return $serializer().new_com_lightningkite_lightningserver_sessions_Session_$serializer_ney2x3_k$(typeSerial0, typeSerial1);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_5gdsw7_k$(typeParamsSerializers[0], typeParamsSerializers[1]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_lightningserver_sessions_Session_$serializer_whgr32_k$();
      }
      static new_com_lightningkite_lightningserver_sessions_Session_$serializer_whgr32_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.Session', $this, 14);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('secretHash', false);
        tmp0_serialDesc.addElement_5pzumi_k$('derivedFrom', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('label', true);
        tmp0_serialDesc.addElement_5pzumi_k$('subjectId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('createdAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('authenticatedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('lastUsed', false);
        tmp0_serialDesc.addElement_5pzumi_k$('expires', true);
        tmp0_serialDesc.addElement_5pzumi_k$('stale', true);
        tmp0_serialDesc.addElement_5pzumi_k$('terminated', true);
        tmp0_serialDesc.addElement_5pzumi_k$('ips', true);
        tmp0_serialDesc.addElement_5pzumi_k$('userAgents', true);
        tmp0_serialDesc.addElement_5pzumi_k$('scopes', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['label', 'subjectId', 'scopes']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['subjectId', 'terminated', 'expires', 'stale']));
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_vpj144_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !value._id_1.equals(Companion_getInstance_0().random_fimq0t_k$())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, UuidSerializer_getInstance(), value._id_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.secretHash_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.derivedFrom_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, UuidSerializer_getInstance(), value.derivedFrom_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.label_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, StringSerializer_getInstance(), value.label_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, this.typeSerial1__1, value.subjectId_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, InstantSerializer_getInstance(), value.createdAt_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.authenticatedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, InstantSerializer_getInstance(), value.authenticatedAt_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, InstantSerializer_getInstance(), value.lastUsed_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.expires_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, InstantSerializer_getInstance(), value.expires_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9) ? true : !(value.stale_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 9, InstantSerializer_getInstance(), value.stale_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !(value.terminated_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 10, InstantSerializer_getInstance(), value.terminated_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 11)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.ips_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 11, tmp2_cached[11].get_value_j01efc_k$(), value.ips_1);
        }
        var tmp_0;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 12)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_0 = !equals(value.userAgents_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 12, tmp2_cached[12].get_value_j01efc_k$(), value.userAgents_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 13) ? true : !equals(value.scopes_1, setOf(new (GrantedScope())(Companion_getInstance().root_1)))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 13, tmp2_cached[13].get_value_j01efc_k$(), value.scopes_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_vpj144_k$(encoder, value instanceof Session() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp19_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp18_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp18_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, UuidSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, this.typeSerial1__1, tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, InstantSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, InstantSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, InstantSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 10, InstantSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 11, tmp19_cached[11].get_value_j01efc_k$(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 12, tmp19_cached[12].get_value_j01efc_k$(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 13, tmp19_cached[13].get_value_j01efc_k$(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp18_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp18_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, UuidSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, this.typeSerial1__1, tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, InstantSerializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, InstantSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, InstantSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 10, InstantSerializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 11, tmp19_cached[11].get_value_j01efc_k$(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 12, tmp19_cached[12].get_value_j01efc_k$(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 13, tmp19_cached[13].get_value_j01efc_k$(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp18_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Session().new_com_lightningkite_lightningserver_sessions_Session_292q9l_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(UuidSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), this.typeSerial1__1, InstantSerializer_getInstance(), get_nullable(InstantSerializer_getInstance()), InstantSerializer_getInstance(), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), tmp0_cached[11].get_value_j01efc_k$(), tmp0_cached[12].get_value_j01efc_k$(), tmp0_cached[13].get_value_j01efc_k$()];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1, this.typeSerial1__1];
      }
      static new_com_lightningkite_lightningserver_sessions_Session_$serializer_ney2x3_k$(typeSerial0, typeSerial1) {
        var $this = this.new_com_lightningkite_lightningserver_sessions_Session_$serializer_whgr32_k$();
        $this.typeSerial0__1 = typeSerial0;
        $this.typeSerial1__1 = typeSerial1;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var SessionClass;
function Session() {
  if (SessionClass === VOID) {
    class $ {
      constructor(_id, secretHash, derivedFrom, label, subjectId, createdAt, authenticatedAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes) {
        Companion_getInstance_1();
        _id = _id === VOID ? Companion_getInstance_0().random_fimq0t_k$() : _id;
        derivedFrom = derivedFrom === VOID ? null : derivedFrom;
        label = label === VOID ? null : label;
        authenticatedAt = authenticatedAt === VOID ? null : authenticatedAt;
        expires = expires === VOID ? null : expires;
        stale = stale === VOID ? null : stale;
        terminated = terminated === VOID ? null : terminated;
        var tmp;
        if (ips === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = ips;
        }
        ips = tmp;
        var tmp_0;
        if (userAgents === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = userAgents;
        }
        userAgents = tmp_0;
        scopes = scopes === VOID ? setOf(new (GrantedScope())(Companion_getInstance().root_1)) : scopes;
        this._id_1 = _id;
        this.secretHash_1 = secretHash;
        this.derivedFrom_1 = derivedFrom;
        this.label_1 = label;
        this.subjectId_1 = subjectId;
        this.createdAt_1 = createdAt;
        this.authenticatedAt_1 = authenticatedAt;
        this.lastUsed_1 = lastUsed;
        this.expires_1 = expires;
        this.stale_1 = stale;
        this.terminated_1 = terminated;
        this.ips_1 = ips;
        this.userAgents_1 = userAgents;
        this.scopes_1 = scopes;
      }
      get__id_18jb1r_k$() {
        return this._id_1;
      }
      toString() {
        return 'Session(_id=' + this._id_1.toString() + ', secretHash=' + this.secretHash_1 + ', derivedFrom=' + toString_0(this.derivedFrom_1) + ', label=' + this.label_1 + ', subjectId=' + toString(this.subjectId_1) + ', createdAt=' + this.createdAt_1.toString() + ', authenticatedAt=' + toString_0(this.authenticatedAt_1) + ', lastUsed=' + this.lastUsed_1.toString() + ', expires=' + toString_0(this.expires_1) + ', stale=' + toString_0(this.stale_1) + ', terminated=' + toString_0(this.terminated_1) + ', ips=' + toString(this.ips_1) + ', userAgents=' + toString(this.userAgents_1) + ', scopes=' + toString(this.scopes_1) + ')';
      }
      hashCode() {
        var result = this._id_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.secretHash_1) | 0;
        result = imul(result, 31) + (this.derivedFrom_1 == null ? 0 : this.derivedFrom_1.hashCode()) | 0;
        result = imul(result, 31) + (this.label_1 == null ? 0 : getStringHashCode(this.label_1)) | 0;
        result = imul(result, 31) + hashCode(this.subjectId_1) | 0;
        result = imul(result, 31) + this.createdAt_1.hashCode() | 0;
        result = imul(result, 31) + (this.authenticatedAt_1 == null ? 0 : this.authenticatedAt_1.hashCode()) | 0;
        result = imul(result, 31) + this.lastUsed_1.hashCode() | 0;
        result = imul(result, 31) + (this.expires_1 == null ? 0 : this.expires_1.hashCode()) | 0;
        result = imul(result, 31) + (this.stale_1 == null ? 0 : this.stale_1.hashCode()) | 0;
        result = imul(result, 31) + (this.terminated_1 == null ? 0 : this.terminated_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.ips_1) | 0;
        result = imul(result, 31) + hashCode(this.userAgents_1) | 0;
        result = imul(result, 31) + hashCode(this.scopes_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Session()))
          return false;
        if (!this._id_1.equals(other._id_1))
          return false;
        if (!(this.secretHash_1 === other.secretHash_1))
          return false;
        if (!equals(this.derivedFrom_1, other.derivedFrom_1))
          return false;
        if (!(this.label_1 == other.label_1))
          return false;
        if (!equals(this.subjectId_1, other.subjectId_1))
          return false;
        if (!this.createdAt_1.equals(other.createdAt_1))
          return false;
        if (!equals(this.authenticatedAt_1, other.authenticatedAt_1))
          return false;
        if (!this.lastUsed_1.equals(other.lastUsed_1))
          return false;
        if (!equals(this.expires_1, other.expires_1))
          return false;
        if (!equals(this.stale_1, other.stale_1))
          return false;
        if (!equals(this.terminated_1, other.terminated_1))
          return false;
        if (!equals(this.ips_1, other.ips_1))
          return false;
        if (!equals(this.userAgents_1, other.userAgents_1))
          return false;
        if (!equals(this.scopes_1, other.scopes_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_Session_292q9l_k$(seen0, _id, secretHash, derivedFrom, label, subjectId, createdAt, authenticatedAt, lastUsed, expires, stale, terminated, ips, userAgents, scopes, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(178 === (178 & seen0))) {
          throwMissingFieldException(seen0, 178, Companion_getInstance_1().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = Companion_getInstance_0().random_fimq0t_k$();
        else
          $this._id_1 = _id;
        $this.secretHash_1 = secretHash;
        if (0 === (seen0 & 4))
          $this.derivedFrom_1 = null;
        else
          $this.derivedFrom_1 = derivedFrom;
        if (0 === (seen0 & 8))
          $this.label_1 = null;
        else
          $this.label_1 = label;
        $this.subjectId_1 = subjectId;
        $this.createdAt_1 = createdAt;
        if (0 === (seen0 & 64))
          $this.authenticatedAt_1 = null;
        else
          $this.authenticatedAt_1 = authenticatedAt;
        $this.lastUsed_1 = lastUsed;
        if (0 === (seen0 & 256))
          $this.expires_1 = null;
        else
          $this.expires_1 = expires;
        if (0 === (seen0 & 512))
          $this.stale_1 = null;
        else
          $this.stale_1 = stale;
        if (0 === (seen0 & 1024))
          $this.terminated_1 = null;
        else
          $this.terminated_1 = terminated;
        if (0 === (seen0 & 2048)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.ips_1 = emptySet();
        } else
          $this.ips_1 = ips;
        if (0 === (seen0 & 4096)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.userAgents_1 = emptySet();
        } else
          $this.userAgents_1 = userAgents;
        if (0 === (seen0 & 8192))
          $this.scopes_1 = setOf(new (GrantedScope())(Companion_getInstance().root_1));
        else
          $this.scopes_1 = scopes;
        return $this;
      }
    }
    initMetadataForClass($, 'Session', VOID, VOID, [HasId()], VOID, VOID, {0: Companion_getInstance_1});
    SessionClass = $;
  }
  return SessionClass;
}
function IdAndAuthMethods$Companion$$childSerializers$_anonymous__wtr52c() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, IdAndAuthMethods$Companion$$childSerializers$_anonymous__wtr52c), null, null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.IdAndAuthMethods', null, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('options', true);
        tmp0_serialDesc.addElement_5pzumi_k$('strengthRequired', true);
        tmp0_serialDesc.addElement_5pzumi_k$('refreshToken', true);
        tmp0_serialDesc.addElement_5pzumi_k$('session', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_af6cag_k$(typeSerial0) {
        return $serializer_0().new_com_lightningkite_lightningserver_sessions_IdAndAuthMethods_$serializer_3wd8xk_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_af6cag_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_2() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_lightningserver_sessions_IdAndAuthMethods_$serializer_f9jv15_k$();
      }
      static new_com_lightningkite_lightningserver_sessions_IdAndAuthMethods_$serializer_f9jv15_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.IdAndAuthMethods', $this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('options', true);
        tmp0_serialDesc.addElement_5pzumi_k$('strengthRequired', true);
        tmp0_serialDesc.addElement_5pzumi_k$('refreshToken', true);
        tmp0_serialDesc.addElement_5pzumi_k$('session', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_baffz0_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, this.typeSerial0__1, value.id_1);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.options_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.options_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.strengthRequired_1 === 1)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.strengthRequired_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.refreshToken_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, StringSerializer_getInstance(), value.refreshToken_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.session_1 == value.refreshToken_1)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, StringSerializer_getInstance(), value.session_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_baffz0_k$(encoder, value instanceof IdAndAuthMethods() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, this.typeSerial0__1, tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, this.typeSerial0__1, tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return IdAndAuthMethods().new_com_lightningkite_lightningserver_sessions_IdAndAuthMethods_l5d3nc_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_2().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1, tmp0_cached[1].get_value_j01efc_k$(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_lightningserver_sessions_IdAndAuthMethods_$serializer_3wd8xk_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_lightningserver_sessions_IdAndAuthMethods_$serializer_f9jv15_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var IdAndAuthMethodsClass;
function IdAndAuthMethods() {
  if (IdAndAuthMethodsClass === VOID) {
    class $ {
      constructor(id, options, strengthRequired, refreshToken) {
        Companion_getInstance_2();
        var tmp;
        if (options === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = options;
        }
        options = tmp;
        strengthRequired = strengthRequired === VOID ? 1 : strengthRequired;
        refreshToken = refreshToken === VOID ? null : refreshToken;
        this.id_1 = id;
        this.options_1 = options;
        this.strengthRequired_1 = strengthRequired;
        this.refreshToken_1 = refreshToken;
        this.session_1 = this.refreshToken_1;
      }
      toString() {
        return 'IdAndAuthMethods(id=' + toString_0(this.id_1) + ', options=' + toString(this.options_1) + ', strengthRequired=' + this.strengthRequired_1 + ', refreshToken=' + this.refreshToken_1 + ')';
      }
      hashCode() {
        var result = this.id_1 == null ? 0 : hashCode(this.id_1);
        result = imul(result, 31) + hashCode(this.options_1) | 0;
        result = imul(result, 31) + this.strengthRequired_1 | 0;
        result = imul(result, 31) + (this.refreshToken_1 == null ? 0 : getStringHashCode(this.refreshToken_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IdAndAuthMethods()))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        if (!equals(this.options_1, other.options_1))
          return false;
        if (!(this.strengthRequired_1 === other.strengthRequired_1))
          return false;
        if (!(this.refreshToken_1 == other.refreshToken_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_IdAndAuthMethods_l5d3nc_k$(seen0, id, options, strengthRequired, refreshToken, session, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance_2().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.id_1 = id;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.options_1 = emptyList();
        } else
          $this.options_1 = options;
        if (0 === (seen0 & 4))
          $this.strengthRequired_1 = 1;
        else
          $this.strengthRequired_1 = strengthRequired;
        if (0 === (seen0 & 8))
          $this.refreshToken_1 = null;
        else
          $this.refreshToken_1 = refreshToken;
        if (0 === (seen0 & 16))
          $this.session_1 = $this.refreshToken_1;
        else
          $this.session_1 = session;
        return $this;
      }
    }
    initMetadataForClass($, 'IdAndAuthMethods', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    IdAndAuthMethodsClass = $;
  }
  return IdAndAuthMethodsClass;
}
function LogInRequest$Companion$$childSerializers$_anonymous__8nyk64() {
  return new (ArrayListSerializer())($serializer_getInstance_1());
}
function LogInRequest$Companion$$childSerializers$_anonymous__8nyk64_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance());
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LogInRequest$Companion$$childSerializers$_anonymous__8nyk64);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [tmp_1, null, lazy(tmp_2, LogInRequest$Companion$$childSerializers$_anonymous__8nyk64_0), null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.LogInRequest', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('proofs', false);
        tmp0_serialDesc.addElement_5pzumi_k$('label', true);
        tmp0_serialDesc.addElement_5pzumi_k$('scopes', true);
        tmp0_serialDesc.addElement_5pzumi_k$('expires', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_l7p7l9_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.proofs_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.label_1 === 'Root Session')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.label_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !equals(value.scopes_1, setOf(new (GrantedScope())(Companion_getInstance().root_1)))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.scopes_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.expires_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), value.expires_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_l7p7l9_k$(encoder, value instanceof LogInRequest() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp9_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp9_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp9_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp9_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp9_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LogInRequest().new_com_lightningkite_lightningserver_sessions_LogInRequest_9xhnqe_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_3().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].get_value_j01efc_k$(), StringSerializer_getInstance(), tmp0_cached[2].get_value_j01efc_k$(), get_nullable(InstantSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance;
function $serializer_getInstance_2() {
  if ($serializer_instance === VOID)
    new ($serializer_1())();
  return $serializer_instance;
}
var LogInRequestClass;
function LogInRequest() {
  if (LogInRequestClass === VOID) {
    class $ {
      constructor(proofs, label, scopes, expires) {
        Companion_getInstance_3();
        label = label === VOID ? 'Root Session' : label;
        scopes = scopes === VOID ? setOf(new (GrantedScope())(Companion_getInstance().root_1)) : scopes;
        expires = expires === VOID ? null : expires;
        this.proofs_1 = proofs;
        this.label_1 = label;
        this.scopes_1 = scopes;
        this.expires_1 = expires;
      }
      toString() {
        return 'LogInRequest(proofs=' + toString(this.proofs_1) + ', label=' + this.label_1 + ', scopes=' + toString(this.scopes_1) + ', expires=' + toString_0(this.expires_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.proofs_1);
        result = imul(result, 31) + getStringHashCode(this.label_1) | 0;
        result = imul(result, 31) + hashCode(this.scopes_1) | 0;
        result = imul(result, 31) + (this.expires_1 == null ? 0 : this.expires_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LogInRequest()))
          return false;
        if (!equals(this.proofs_1, other.proofs_1))
          return false;
        if (!(this.label_1 === other.label_1))
          return false;
        if (!equals(this.scopes_1, other.scopes_1))
          return false;
        if (!equals(this.expires_1, other.expires_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_LogInRequest_9xhnqe_k$(seen0, proofs, label, scopes, expires, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.proofs_1 = proofs;
        if (0 === (seen0 & 2))
          $this.label_1 = 'Root Session';
        else
          $this.label_1 = label;
        if (0 === (seen0 & 4))
          $this.scopes_1 = setOf(new (GrantedScope())(Companion_getInstance().root_1));
        else
          $this.scopes_1 = scopes;
        if (0 === (seen0 & 8))
          $this.expires_1 = null;
        else
          $this.expires_1 = expires;
        return $this;
      }
    }
    initMetadataForClass($, 'LogInRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    LogInRequestClass = $;
  }
  return LogInRequestClass;
}
function ProofsCheckResult$Companion$$childSerializers$_anonymous__gqv6ms() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, ProofsCheckResult$Companion$$childSerializers$_anonymous__gqv6ms), null, null, null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.ProofsCheckResult', null, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('options', true);
        tmp0_serialDesc.addElement_5pzumi_k$('strengthRequired', true);
        tmp0_serialDesc.addElement_5pzumi_k$('readyToLogIn', false);
        tmp0_serialDesc.addElement_5pzumi_k$('maxExpiration', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_af6cag_k$(typeSerial0) {
        return $serializer_2().new_com_lightningkite_lightningserver_sessions_ProofsCheckResult_$serializer_3ihzvu_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_af6cag_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_lightningserver_sessions_ProofsCheckResult_$serializer_v1frvr_k$();
      }
      static new_com_lightningkite_lightningserver_sessions_ProofsCheckResult_$serializer_v1frvr_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.sessions.ProofsCheckResult', $this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('options', true);
        tmp0_serialDesc.addElement_5pzumi_k$('strengthRequired', true);
        tmp0_serialDesc.addElement_5pzumi_k$('readyToLogIn', false);
        tmp0_serialDesc.addElement_5pzumi_k$('maxExpiration', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_yzv9gw_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_4().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, this.typeSerial0__1, value.id_1);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.options_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.options_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.strengthRequired_1 === 1)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.strengthRequired_1);
        }
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 3, value.readyToLogIn_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, InstantSerializer_getInstance(), value.maxExpiration_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_yzv9gw_k$(encoder, value instanceof ProofsCheckResult() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_4().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, this.typeSerial0__1, tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, this.typeSerial0__1, tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProofsCheckResult().new_com_lightningkite_lightningserver_sessions_ProofsCheckResult_2ur8vu_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_4().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1, tmp0_cached[1].get_value_j01efc_k$(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(InstantSerializer_getInstance())];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_lightningserver_sessions_ProofsCheckResult_$serializer_3ihzvu_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_lightningserver_sessions_ProofsCheckResult_$serializer_v1frvr_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var ProofsCheckResultClass;
function ProofsCheckResult() {
  if (ProofsCheckResultClass === VOID) {
    class $ {
      constructor(id, options, strengthRequired, readyToLogIn, maxExpiration) {
        Companion_getInstance_4();
        var tmp;
        if (options === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = options;
        }
        options = tmp;
        strengthRequired = strengthRequired === VOID ? 1 : strengthRequired;
        this.id_1 = id;
        this.options_1 = options;
        this.strengthRequired_1 = strengthRequired;
        this.readyToLogIn_1 = readyToLogIn;
        this.maxExpiration_1 = maxExpiration;
      }
      toString() {
        return 'ProofsCheckResult(id=' + toString_0(this.id_1) + ', options=' + toString(this.options_1) + ', strengthRequired=' + this.strengthRequired_1 + ', readyToLogIn=' + this.readyToLogIn_1 + ', maxExpiration=' + toString_0(this.maxExpiration_1) + ')';
      }
      hashCode() {
        var result = this.id_1 == null ? 0 : hashCode(this.id_1);
        result = imul(result, 31) + hashCode(this.options_1) | 0;
        result = imul(result, 31) + this.strengthRequired_1 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.readyToLogIn_1) | 0;
        result = imul(result, 31) + (this.maxExpiration_1 == null ? 0 : this.maxExpiration_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProofsCheckResult()))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        if (!equals(this.options_1, other.options_1))
          return false;
        if (!(this.strengthRequired_1 === other.strengthRequired_1))
          return false;
        if (!(this.readyToLogIn_1 === other.readyToLogIn_1))
          return false;
        if (!equals(this.maxExpiration_1, other.maxExpiration_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_sessions_ProofsCheckResult_2ur8vu_k$(seen0, id, options, strengthRequired, readyToLogIn, maxExpiration, serializationConstructorMarker) {
        Companion_getInstance_4();
        if (!(25 === (25 & seen0))) {
          throwMissingFieldException(seen0, 25, Companion_getInstance_4().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.id_1 = id;
        if (0 === (seen0 & 2)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.options_1 = emptyList();
        } else
          $this.options_1 = options;
        if (0 === (seen0 & 4))
          $this.strengthRequired_1 = 1;
        else
          $this.strengthRequired_1 = strengthRequired;
        $this.readyToLogIn_1 = readyToLogIn;
        $this.maxExpiration_1 = maxExpiration;
        return $this;
      }
    }
    initMetadataForClass($, 'ProofsCheckResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    ProofsCheckResultClass = $;
  }
  return ProofsCheckResultClass;
}
//region block: exports
export {
  IdAndAuthMethods as IdAndAuthMethods16spukjsbhqxj,
  LogInRequest as LogInRequest2g40z29mrhnaf,
  ProofsCheckResult as ProofsCheckResultbn4a1zrk4ejf,
  Session as Session1fsuafg4xfsqb,
  Companion_getInstance_2 as Companion_getInstance2dipyncjirnxu,
  Companion_getInstance_3 as Companion_getInstance3jr0y3h9aenfk,
  Companion_getInstance_4 as Companion_getInstance35gn67k9ocaua,
  Companion_getInstance_1 as Companion_getInstance2v1f7yxfwu10q,
};
//endregion

//# sourceMappingURL=sessionModels.mjs.map
